module.exports = ":host img {\n  margin-right: 8px; }\n\n:host mat-toolbar {\n  font-weight: normal;\n  color: white;\n  background-color: #57c2ec;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100% !important; }\n\n:host mat-toolbar .title {\n    font-weight: lighter;\n    font-style: italic;\n    margin-right: 32px; }\n\n:host mat-toolbar .home {\n    cursor: pointer; }\n\n:host mat-toolbar .spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.scss
// module id = ./src/app/shared/navbar/navbar.component.scss
// module chunks = main